
const Constants =
{
    SERVER_URL: "https://dev.aeoaudited.com",
    TOKEN_NAME: "aeoaudited-token",
    USER_EMAIL: 'aeoaudited-user-email',
    USER_ID: 'aeoaudited-user-id',  
    SIGNUP_USER_EMAIL: 'signup-user-email',    
    SIGNUP_SELECTED_PLAN: 'signup-selected-plan',
};

module.exports = Constants;
